import Input from '../../../Input/Input';
import { Controller, useForm } from 'react-hook-form';
import { parseSubdomain } from 'src/helpers/getSubdomainHelper';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';
import type { IntegrationSubmitHandler } from 'src/components/Integrations/integrationFormTypes';

interface FreshdeskFormValues {
  subdomain: string;
  api_key: string;
}

const isLongerThanTwo = (value: string) => Boolean(value && value.length > 2);

export const IntegrationFormFreshdesk = ({
  integration,
  onSubmit,
}: {
  integration?: SelectedIntegration;
  onSubmit?: IntegrationSubmitHandler;
}) => {
  const { handleSubmit, control, clearErrors } = useForm<FreshdeskFormValues>({
    mode: 'onBlur',
    defaultValues: {
      subdomain: integration.integration_data.subdomain || '',
      api_key: integration.integration_data?.api_key || '',
    },
  });

  const submit = (values: FreshdeskFormValues) => {
    const data = {
      ...integration,
      integration_data: {
        ...integration.integration_data,
        api_key: values.api_key || '',
        subdomain: parseSubdomain(values.subdomain),
      },
    };

    onSubmit(data);
  };

  return (
    <form id="integration-form" onSubmit={handleSubmit(submit)}>
      <div className={'input-container'}>
        <Input
          type={'text'}
          label={'Integration Type'}
          placeholder={'Integration Type'}
          value={integration.integration_type}
          readonly={true}
          isValid={true}
        />
      </div>
      <div className={'input-container'}>
        <Controller
          control={control}
          name="subdomain"
          rules={{
            validate: (value) => isLongerThanTwo(value) || (value ? 'Invalid Format' : 'Required'),
          }}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Subdomain'}
              placeholder={'Subdomain'}
              value={value}
              invalidMessage={error?.message}
              isValid={!error}
              onChange={(event) => onChange(parseSubdomain(event.currentTarget.value))}
              onBlur={onBlur}
              onFocus={() => clearErrors('subdomain')}
            />
          )}
        />
      </div>
      <div className="sub-title items-start md:flex-row flex-col gap-[16px] md:gap-[20px]">
        <h4>Credentials:</h4>
      </div>
      <div className={'input-container'}>
        <Controller
          control={control}
          name="api_key"
          rules={{ validate: (value) => isLongerThanTwo(value) || 'Invalid' }}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type={'password'}
              label={'API Key'}
              placeholder={'••••••••••••••••••••••••••••'}
              invalidMessage={error?.message}
              isValid={!error}
              value={value}
              onChange={(event) => onChange(event.currentTarget.value)}
              onBlur={onBlur}
              onFocus={() => clearErrors('api_key')}
            />
          )}
        />
      </div>
    </form>
  );
};
